
import { Handshake, Trash2 } from "lucide-react";
import { DealStatus, type Deal } from "@/types/crm";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { getStatusClasses } from "@/lib/status-variants";
import { Breadcrumb } from "@/components/ui/breadcrumb";
import { AskAiButton } from "@/components/assistant/assistant-provider";

const statusLabels: Record<DealStatus, string> = {
  [DealStatus.Open]: "Open",
  [DealStatus.Won]: "Won",
  [DealStatus.Lost]: "Lost",
};

interface DealDetailHeaderProps {
  deal: Deal;
  onDelete?: () => void;
}

export function DealDetailHeader({ deal, onDelete }: DealDetailHeaderProps) {
  return (
    <div className="space-y-1.5">
      <Breadcrumb
        items={[
          { label: "Deals", href: "/dashboard/deals" },
          { label: deal.dealTypeName ?? "Deal" },
        ]}
      />
      <div className="flex items-center gap-2 flex-wrap">
        <Handshake className="h-5 w-5 text-muted-foreground shrink-0" />
        <h1 className="text-2xl font-semibold tracking-tight truncate">{deal.dealTypeName}</h1>
        <Badge className={getStatusClasses(statusLabels[deal.status])}>
          {statusLabels[deal.status]}
        </Badge>
        <div className="ml-auto flex items-center gap-1">
          <AskAiButton />
          {onDelete && (
            <Button variant="ghost" size="icon" className="size-9 text-muted-foreground hover:text-destructive" onClick={onDelete} title="Delete deal">
              <Trash2 className="h-4 w-4" />
            </Button>
          )}
        </div>
      </div>
      {deal.description && (
        <p className="text-sm text-muted-foreground">{deal.description}</p>
      )}
    </div>
  );
}
